/*--------------------------------------------------------------
 The following JavaScript functions are for page initialisation
----------------------------------------------------------------*/

// These funstions will be run on ever page after it's bee loaded
$().ready(function() {

    // Whether to display the booking basket
    TECL_BookingBasket.DisplayBookingBasket();
});
